export default __webpack_public_path__ + "2c5f0fc1b78eafa3967868fb46462515.png";